import { render, staticRenderFns } from "./BlockUserIncidents.vue?vue&type=template&id=773d040a&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./BlockUserIncidents.vue?vue&type=script&lang=js"
export * from "./BlockUserIncidents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773d040a",
  null
  
)

export default component.exports